export default "__VITE_ASSET__B$kxuxma__"